/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AccountUpdateRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/AccountUpdate.pb'
import {AccountUpdateResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/AccountUpdate.pb'


export const accountUpdate = (request: AccountUpdateRequest, options?: CashRequestOptions) => post<AccountUpdateRequest, AccountUpdateResponse>("/2.0/cash/account-update", request, {...options, rejectOnError: true })